<app-widget-panel [widgetStyle]="widgetPanel.style">
  <div class="container-fluid h-100 overflow-hidden d-flex flex-column">
    <div class="row">
      <h3 class="vive-blue text-center">{{ title }}</h3>
    </div>

    <div class="row inner-panel-container flex-grow-1">
      @for (
        innerPanelTemplateRef of innerPanelTemplateRefs;
        track innerPanelTemplateRef
      ) {
        <ng-container [ngTemplateOutlet]="innerPanelTemplateRef"></ng-container>
      }

      <!--
      <div *ngFor="let innerPanelTemplateRef of innerPanelTemplateRefs; index as i;" [ngClass]="getPanelClass(i)" class="inner-panel" (scroll)="onScroll($event)">
        <ng-container [ngTemplateOutlet]="innerPanelTemplateRef"></ng-container>
      </div>
      -->
    </div>
  </div>
</app-widget-panel>
